// Apolo IDE — SessionStatusBadge (sprint code-session-board, E2-WS2).
//
// Pill compacto de status: ÍCONE + TEXTO (nunca cor sozinha — a11y). A cor é
// reforço, não o único sinal. `title`/aria carregam o reason pro leitor de tela.
// Quando a sessão está EM ATIVIDADE (running/review/needs_you/blocked) o dot
// ganha cor + glow; idle fica cinza apagado.

import { Loader2, AlertTriangle, GitPullRequest, CircleDot, Circle } from 'lucide-react';
import { sessionStatusMeta } from '../../lib/code/sessionStatusMeta.js';

const ICONS = { Loader2, AlertTriangle, GitPullRequest, CircleDot, Circle };

// tone → { color (token --apolo-*), glow }. running=verde · review=azul ·
// needs_you=amarelo · blocked=vermelho · idle=cinza (sem glow).
const TONE = {
  success: { color: 'var(--apolo-success)', glow: true },       // running → verde
  info:    { color: 'var(--apolo-accent)', glow: true },        // review → azul (#3b82f6)
  warn:    { color: 'var(--apolo-warning)', glow: true },       // needs_you → amarelo
  danger:  { color: 'var(--apolo-error)', glow: true },         // blocked → vermelho
  accent:  { color: 'var(--apolo-accent)', glow: true },        // fallback
  neutral: { color: 'var(--apolo-textTertiary)', glow: false }, // idle → cinza
};

export default function SessionStatusBadge({ status, compact = false }) {
  const key = typeof status === 'string' ? status : status?.status;
  const reason = typeof status === 'object' && status ? status.reason : '';
  const meta = sessionStatusMeta(key);
  const Icon = ICONS[meta.icon] || Circle;
  const t = TONE[meta.tone] || TONE.neutral;
  const label = `${meta.label}${reason ? ` — ${reason}` : ''}`;

  return (
    <span
      className="inline-flex shrink-0 items-center gap-1"
      title={label}
      role="status"
      aria-label={`Status: ${label}`}
      style={{ color: t.color }}
    >
      <Icon
        size={12}
        aria-hidden="true"
        className={key === 'running' ? 'animate-spin' : ''}
        strokeWidth={2.25}
        style={t.glow ? { filter: `drop-shadow(0 0 4px ${t.color})` } : undefined}
      />
      {compact ? null : <span className="text-[10px] font-medium leading-none">{meta.label}</span>}
    </span>
  );
}
